module.exports = __webpack_public_path__ + "img/76036.be15e134.svg";